import React from 'react';
import { Grid } from '@material-ui/core';
import ErrorBoundary from 'app/components/ErrorBoundary';

interface FragmentWrapperProps {
  name: string;
  children: React.ReactNode;
}
export const FragmentWrapper = (props: FragmentWrapperProps) => {
  return (
    <ErrorBoundary>
      <Grid item lg={12} spacing={2} container>
        {props.children}
      </Grid>
    </ErrorBoundary>
  );
};
